import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import Topbar from "@/components/layout/Topbar";
import { formatDateTime } from "@/lib/format";

const ACTIONS = ["", "login", "logout", "create", "update", "delete", "sync", "subscribe"];

export default function AuditLogs() {
    const [logs, setLogs] = useState([]);
    const [action, setAction] = useState("");

    const load = async () => {
        const params = new URLSearchParams();
        if (action) params.set("action", action);
        const { data } = await api.get(`/audit/logs?${params}`);
        setLogs(data);
    };
    useEffect(() => { load(); /* eslint-disable-next-line */ }, [action]);

    return (
        <>
            <Topbar title="Audit Logs" subtitle={`${logs.length} entries`} />
            <div className="flex-1 overflow-auto p-6">
                <div className="mb-3 flex items-center gap-2">
                    <select value={action} onChange={(e) => setAction(e.target.value)} className="akm-input h-8 w-[180px]" data-testid="audit-filter-action">
                        {ACTIONS.map((a) => <option key={a} value={a}>{a || "All actions"}</option>)}
                    </select>
                </div>
                <div className="akm-card overflow-hidden">
                    <table className="akm-table w-full">
                        <thead className="bg-muted/40">
                            <tr><th>Time</th><th>User</th><th>Action</th><th>Resource</th><th>Resource ID</th><th>IP</th></tr>
                        </thead>
                        <tbody>
                            {logs.map((l) => (
                                <tr key={l.id}>
                                    <td className="font-mono text-[12px] text-muted-foreground">{formatDateTime(l.created_at)}</td>
                                    <td>{l.user_email || "—"}</td>
                                    <td><span className="rounded-md bg-muted px-2 py-0.5 text-[11px] font-medium capitalize">{l.action}</span></td>
                                    <td className="capitalize">{l.resource}</td>
                                    <td className="font-mono text-[11px] text-muted-foreground">{l.resource_id ? l.resource_id.slice(0, 8) : "—"}</td>
                                    <td className="text-muted-foreground">{l.ip || "—"}</td>
                                </tr>
                            ))}
                            {logs.length === 0 && <tr><td colSpan="6" className="py-12 text-center text-muted-foreground">No logs</td></tr>}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
